import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/add_funds.svg")